/*
Author : Raphaël Dardeau


Markup : 

<div class="js-filters">
	<ul class="js-filters-ctrl">
		<li class="js-filters-all"><a href="#">Tous</a></li>
		<li data-filters-tag="sport"><a href="#">tag 1 (<span class="js-filters-count">2</span>)</a></li>
		<li data-filters-tag="music"><a href="#">tag 2 (<span class="js-filters-count">1</span>)</a></li>
	</ul>
	<div data-filters-content="sport">
		sport 1
	</div>
	<div data-filters-content="sport">
		sport 2
	</div>
	<div data-filters-content="music">
		music 1
	</div>
</div>


Setup :
 
$(function() {
    $(".js-filters").filtering();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "filtering",
        defaults = {
            ctrlElement: ".js-filters-ctrl",
            allElement: ".js-filters-all",
            filterClass: "is-active",
			counterElements: ".js-filters-count",
			excludeEmpty: true
        };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setElements();
			this.setFilters();
            this.setEvents();
            this.selectAll();
         },
        setElements: function () {
            this.$element = $(this.element);
            this.$contents = this.$element.find("[data-filters-content]");
            this.$filtersList = this.$element.find("[data-filters-tpl]");
            this.tplId = this.$filtersList.data("filters-tpl");
            this.tpl = $(this.tplId).html();
            $(this.tplId).remove();
        },
        setEvents: function () {
            $(document).on("click", "[data-filters-tag]", $.proxy(function(e) {
				this.$filter = $(e.currentTarget);
				this.selectFilter();
				e.preventDefault();
			}, this));
            $(document).on("click", this.settings.allElement,$.proxy(function(e) {
				this.selectAll();
				e.preventDefault();
			}, this));
        },
		setFilters: function() {
			var _this = this;
			var counterElement = this.settings.counterElements;
			var excludeEmpty = this.settings.excludeEmpty;
			var filtersCounter = [];
			var filters = [];
			this.$contents.each(function(i) {
				var tag = $(this).data("filters-content");
				var label = $(this).data("filters-label");
				if (!filtersCounter[tag]) {
					filters.push({
						tag:tag,
						label:label,
						count:1
					});
					filtersCounter[tag] = 1;
				} else 
					filtersCounter[tag]++;
			});
            Mustache.parse(this.tpl);
            var html = Mustache.render(this.tpl, filters);
            this.$filtersList.html(html);
            this.$all = this.$element.find(this.settings.allElement);
            this.$filters = this.$element.find("[data-filters-tag]");
			if (this.$contents.length) {
				this.$all.addClass("is-active").find(counterElement).text(this.$contents.length);
				$(this.settings.ctrlElement).show();
			} else {
				$(this.settings.ctrlElement).hide();
			}
			this.$filters.each(function(i) {
				var tag = $(this).data("filters-tag");
				if (filtersCounter[tag]) {
					$(this).find(counterElement).text(filtersCounter[tag]);
					$(this).addClass("is-active").removeClass("is-empty");
				} else {
					$(this).find(counterElement).text(0);
					$(this).removeClass("is-active").addClass("is-empty");
				}
			});
			this.filtersCounter = filtersCounter;
			this.setFiltersNewrow();
        },
        setFiltersNewrow: function () {
        	this.$filters.add(this.$all).removeClass("filters__item--newrow").filter(":not(.is-empty)").each(function(i) {
				if (i++ % 4 == 0) 
					$(this).addClass("filters__item--newrow");
			});
        },
        selectFilter: function() {
			if (this.$all.hasClass("is-active")) {
				this.$all.removeClass("is-active");
				this.$filters.removeClass("is-active");
				this.$filter.addClass("is-active");
			} else {
				if (!this.$filter.hasClass("is-active")) {
					this.$filter.addClass("is-active");
				} else {
					this.$filter.removeClass("is-active");
				}
			}
			this.setContents();
			if (this.$filters.filter(".is-active").length == Object.keys(this.filtersCounter).length)
				this.$all.addClass("is-active");
			else if (!this.$filters.filter(".is-active").length)
				this.$all.trigger("click");
			this.setContentsNewrow();
			this.$element.trigger("filtering");
        },
		selectAll: function() {
			if (!this.$all.hasClass("is-active")) {
				this.$all.addClass("is-active");
				this.$filters.addClass("is-active");
				this.setContents();
				this.setContentsNewrow();
				this.$element.trigger("filtering");
			}
        },
        setContents: function() {
			if (this.$all.hasClass("is-active")) {
				this.$contents.show();
			} else {
				this.$contents.hide();
				var _this = this;
				this.$filters.filter(".is-active").each(function(i) {
					_this.$contents.filter("[data-filters-content='"+ $(this).data("filters-tag") +"']").show();
				});
			}
        },
        setContentsNewrow: function () {
        	this.$contents.removeClass("slot--newrow").filter(":visible").each(function(i) {
				if (i++ % 3 == 0) 
					$(this).addClass("slot--newrow");
			});
        },
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);